import { Token } from "./TokenEnum";
import { TokenMetadata } from "./getTokenMetadata";
import { Amount } from "../../types/amount";
import { arbitrum, mainnet, polygon } from "wagmi/chains";
import { Chain } from "viem/chains";
import { readContract } from "wagmi/actions";
import { BALANCES_ALLOWANCES_CONTRACT_ABI } from "../../config/abis/BalancesAllowancesContract.abi";
import { getTokenDecimals } from "./getAllowances";
import { Balance } from "./getBalances";

export type Balances = Array<Balance>;
type ChainId = Chain["id"];

const NATIVE_TOKEN_ADDRESS: `0x${string}` = "0x0000000000000000000000000000000000000000";
const BALANCE_CONTRACTS: Record<ChainId, `0x${string}`> = {
  [mainnet.id]: "0x21486E4427031F10fBE45F47AAd6f729014d42a4",
  [polygon.id]: "0x132F13C3896eAB218762B9e46F55C9c478905849",
  [arbitrum.id]: "0xf8D3B856cc0A9c99A5b849246b8E679E32298E1c",
};
export const fetchBalancesFast = async (
  userAddress: string,
  tokens: TokenMetadata,
  network: Chain
): Promise<Balances> => {
  if (network && tokens) {
    const tokenSymbols = [...(Object.keys(tokens) as Array<Token>)];
    const tokensAddresses = tokenSymbols.map(symbol => {
      if (symbol === network.nativeCurrency.symbol) {
        return NATIVE_TOKEN_ADDRESS;
      }
      const contractAddress = tokens[symbol]?.chainInfo[0].contractAddress;
      return contractAddress;
    }) as Array<`0x${string}`>;
    return readContract({
      address: BALANCE_CONTRACTS[network.id],
      abi: BALANCES_ALLOWANCES_CONTRACT_ABI,
      functionName: "walletBalances",
      args: [userAddress as `0x${string}`, tokensAddresses],
    })
      .then(res => {
        const balances = res.map((balanceBigInt, index) => {
          const tokenDecimals = getTokenDecimals(tokenSymbols[index], tokens);
          const divisor = new Amount((10 ** tokenDecimals).toString());
          const balance = new Amount(balanceBigInt.toString()).div(divisor);
          return { symbol: tokenSymbols[index], balance: balance };
        });
        return balances;
      })
      .catch(err => {
        console.error(`Balances error error`, err);
        return [];
      });
  }
  return [];
};
